import { EmptyStateProcessTemplateStepsIllustration } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { EmptyPage } from "~/components/EmptyPage/EmptyPage";
export function ProcessTemplateStepDetailsEmptyState() {
    const title = `This step is not available to edit.`;
    const description = "To view step details, go to the template in Platform Hub.";
    return <EmptyPage title={title} description={description} image={<EmptyStateProcessTemplateStepsIllustration />} isCompact={true}/>;
}
